import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import { downloadCSV } from "../../utils";

const ActionButtons = ({
  editing,
  onAddClick,
  type,
  size,
  filters,
  setFilters,
  setModalOpen,
  FilterComponent,
  resetFilters,
  onEditClick,
  onSaveClick,
  client,
  name,
  query,
  columns,
  where,
  children,
  readOnly,
  isDispatcher,
  orderByMulti = []
}) => {
  const isOnEmployeesPage = useLocation().pathname.includes("employees");

  console.log({ isOnEmployeesPage });

  return (
    <div className="page-head-end">
      {type === "edit" ? (
        <Field kind="group">
          <Control>
            <Button
              color="primary"
              disabled={editing || (isDispatcher && isOnEmployeesPage)}
              onClick={onEditClick}
            >
              <Icon>
                <FontAwesomeIcon icon="edit" />
              </Icon>
              <span>Edit</span>
            </Button>
          </Control>
          <Control>
            <Button
              color="success"
              disabled={!editing || (isDispatcher && isOnEmployeesPage)}
              onClick={onSaveClick}
            >
              <Icon>
                <FontAwesomeIcon icon="save" />
              </Icon>
              <span>Save</span>
            </Button>
          </Control>
        </Field>
      ) : (
        <Field kind="group">
          {children}
          <Control>
            <Button
              color="danger"
              disabled={isDispatcher && isOnEmployeesPage}
              size={size}
              onClick={() =>
                setModalOpen(
                  true,
                  <FilterComponent
                    filters={filters}
                    resetFilters={resetFilters}
                    onClose={() => setModalOpen(false)}
                    onFilter={setFilters}
                  />
                )
              }
            >
              <Icon>
                <FontAwesomeIcon icon="filter" />
              </Icon>
              <span>Filter</span>
            </Button>
          </Control>
          <Control>
            <Button
              color="primary"
              disabled={isDispatcher && isOnEmployeesPage}
              size={size}
              onClick={() =>
                downloadCSV(
                  client,
                  {
                    query,
                    where: where ? { ...where } : { ...filters },
                    orderByMulti
                  },
                  name,
                  columns
                )
              }
            >
              <Icon>
                <FontAwesomeIcon icon="file-export" />
              </Icon>
              <span>Export</span>
            </Button>
          </Control>
          {onAddClick && (
            <Control>
              <Button
                color="success"
                disabled={readOnly || (isDispatcher && isOnEmployeesPage)}
                size={size}
                onClick={onAddClick}
              >
                <Icon>
                  <FontAwesomeIcon icon="plus" />
                </Icon>
                <span>Add</span>
              </Button>
            </Control>
          )}
        </Field>
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  onAddClick: PropTypes.func,
  setFilters: PropTypes.func,
  setModalOpen: PropTypes.func,
  resetFilters: PropTypes.func,
  onEditClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  query: PropTypes.object,
  filters: PropTypes.object,
  client: PropTypes.object,
  editing: PropTypes.bool,
  FilterComponent: PropTypes.node,
  columns: PropTypes.array,
  where: PropTypes.object,
  readOnly: PropTypes.bool,
  children: PropTypes.node,
  orderByMulti: PropTypes.array,
  isDispatcher: PropTypes.bool
};

ActionButtons.defaultProps = {};

export default ActionButtons;
